import React, { useState } from 'react';
import { Grid, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import StyledButton from '../../Common/StyledButton';
import AddClient from '../../AddClientModal/AddClientModal';
import createPermissionCheckers from '../../../permissions-validation/createPermissionCheckers';
import { UserPermissionType } from '../../../types/commonTypes';

export interface IClentsEmptyProps {
  addExtraBottomMargin?: boolean;
  isClientGroupPath?: boolean;
  clientGroupId?: string;
}

function CilentsEmpty({
  addExtraBottomMargin,
  isClientGroupPath,
  clientGroupId,
}: Readonly<IClentsEmptyProps>) {
  const { t } = useTranslation();
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const handleAddClient = () => {
    setIsOpen(true);
  };

  const permissionCheckers = createPermissionCheckers();
  const { checkPermissions } = permissionCheckers;
  const height = addExtraBottomMargin ? '90%' : '100%';

  return (
    <Grid
      container
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height={height}
      gap="36px"
      bgcolor="#fff"
      boxShadow={theme.borderStyles.cardBorders}
    >
      <Grid>
        <img src="/assets/icons/user-plus-large.svg" alt="user-plus-large" />
      </Grid>
      <Grid item xs={4} textAlign="center" gap="16px" display="flex" flexDirection="column">
        <Grid>
          <Typography variant="title2Bold" color="primary">
            {t('clientTable.emptyClients.title')}
          </Typography>
        </Grid>
        <Grid gap="24px" display="flex" flexDirection="column">
          <Typography variant="bodyRegular" color="primary" fontWeight={500}>
            {t('clientTable.emptyClients.descriptionPart1')}
          </Typography>
          <Typography variant="bodyRegular" color="primary" fontWeight={500}>
            {t('clientTable.emptyClients.descriptionPart2')}
          </Typography>
          <Typography variant="bodyRegular" color="primary" fontWeight={500}>
            {t('clientTable.emptyClients.descriptionPart3')}
          </Typography>
        </Grid>
      </Grid>
      {(checkPermissions(UserPermissionType.CORE_MODULE_ADD_NEW_CLIENT) ||
        checkPermissions(UserPermissionType.CLIENT_GROUP_MODULE_EDIT_CLIENT_GROUP)) && (
        <Grid>
          <StyledButton onClick={handleAddClient} fullWidth paddingX={100}>
            {t('clientTable.emptyClients.button')}
          </StyledButton>
          {isOpen && (
            <AddClient
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
              isClientGroupPath={isClientGroupPath}
              clientGroupId={clientGroupId}
            />
          )}
        </Grid>
      )}
    </Grid>
  );
}

export default CilentsEmpty;
